export class NullYamlTransformer {
    preProcessOption(option) {
    }
    preProcessProduct(product) {
    }
    preProcessOptionGroups(optionGroup) {
    }
    postProcessProduct(product) {
    }
}
//# sourceMappingURL=YamlTransformer.js.map